export const mutation_postFascicolo = `
    mutation postFascicolo(        
        $tenantId: String!
        $aziendaId: Int!
        $dataInput: InputDataFascicolo!
    ) {
        postFascicolo(
            tenantId: $tenantId
            aziendaId: $aziendaId
            dataInput: $dataInput
        ) {
            id
            tenantId
            name
            date
            isPrivate
            createdOn
            modifiedOn
            aziendaId
            createdBy
            modifiedBy
        }
    }
`;
export const mutation_updateFascicolo = `
    mutation updateFascicolo(
        $id: Int!
        $userId: String!
        $aziendaId: Int!
        $dataInput: InputDataFascicolo!
    ) {
        updateFascicolo(
            id: $id
            userId: $userId
            aziendaId: $aziendaId
            dataInput: $dataInput
        ) {
            id
            tenantId
            name
            date
            isPrivate
            createdOn
            modifiedOn
            aziendaId
            createdBy
            modifiedBy
        }
    }
`;
export const mutation_deleteFascicolo = `
    mutation deleteFascicolo(
        $id: Int!        
        $aziendaId: Int!
    ) {
        deleteFascicolo(
            id: $id            
            aziendaId: $aziendaId
        ) {
            success
            message
        }
    }
`;